import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export function getUserInfo() {
  const token = Cookies.get("token");
  if(token){
    let decoded = ''
   try {
    decoded= jwtDecode(token);
   } catch (error) {
    console.log(error)
   }
   const parse = JSON.stringify(decoded);
   return JSON.parse(parse);
  }else{
    return null
  }
}
export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

export function formatCurrentStartDate(date: any) {
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1).padStart(2, "0");
  const day = String(date?.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00.000Z`;
}

export function formatCurrentEndDate(date: any) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T23:59:59.000Z`;
}

export function useRTL(isArabic: any) {
  const direction = isArabic ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", direction);
}

export function currentLang() {
  const lang = localStorage.getItem("lang");
  return lang;
}

export function formatDate(inputdate: any) {
  const date = new Date(inputdate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatTime(inputdate: any) {
  const date = new Date(inputdate);
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return `${hours}:${minutes} ${ampm}`;
}

export function formatNumber(number: any) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(number));
}
export function formatNumberWithoutFraction(number: any) {
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(Number(number));
}

/** Sales achievement (live) KPI: never show or chart a negative live_updated_cartons_target_count. */
export function nonNegativeLiveTargetCartons(raw: unknown): number {
  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, n) : 0;
}

export function TimeZoneDisplay() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getPagePerSize() {
  return 20;
}
export function getRoleAccess(data:string) {
    const userTeams = localStorage.getItem('section') || '';
    const hasAccess = userTeams.includes(data);
  return hasAccess
}

export function formatMinutes(
  minutes: number,
  style: 'mm:ss' | 'hh:mm:ss' | 'human' = 'mm:ss',
  rounding: 'floor' | 'round' | 'ceil' = 'round'
): string {
  const totalSecondsRaw = minutes * 60;
  const totalSeconds =
    rounding === 'ceil'
      ? Math.ceil(totalSecondsRaw)
      : rounding === 'floor'
      ? Math.floor(totalSecondsRaw)
      : Math.round(totalSecondsRaw);

  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, "0");

  if (style === 'human') {
    const parts: string[] = [];
    if (hours) parts.push(`${hours}h`);
    if (mins) parts.push(`${mins}m`);
    if (secs || parts.length === 0) parts.push(`${secs}s`);
    return parts.join(' ');
  }

  if (style === 'hh:mm:ss') {
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }

  const totalMins = hours * 60 + mins;
  return `${pad(totalMins)}:${pad(secs)}`;
}

export function ratingToText(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  const map: Record<number, string> = {
    1: "Poor",
    2: "Fair",
    3: "Good",
    4: "Very Good",
    5: "Excellent",
  };
  return map[num] ?? String(value);
}

export function printElement(elementId: string): Promise<boolean> {
  return new Promise((resolve) => {
    const printContent = document.getElementById(elementId);
    if (!printContent) {
      console.error(`Element with id ${elementId} not found`);
      resolve(false);
      return;
    }

    // Find or create the print iframe
    let iframe = document.getElementById("print-iframe") as HTMLIFrameElement;
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.id = "print-iframe";
      iframe.style.position = "absolute";
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.style.border = "none";
      iframe.style.top = "-9999px";
      iframe.style.left = "-9999px";
      document.body.appendChild(iframe);
    }

    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc) {
      console.error("Could not access iframe document");
      resolve(false);
      return;
    }

    const isArabic = currentLang() === "Arabic" || document.documentElement.getAttribute("dir") === "rtl";

    iframeDoc.open();
    iframeDoc.write(`
      <html>
        <head>
          <title>Print</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" />
          <style>
            @page {
              margin: 0;
            }
            body {
              padding: 15mm;
              direction: ${isArabic ? "rtl" : "ltr"};
              text-align: ${isArabic ? "right" : "left"};
              font-family: 'Arial', sans-serif;
            }
            #${elementId} {
              display: block !important;
              visibility: visible !important;
            }
            @media print {
              img {
                print-color-adjust: exact !important;
                -webkit-print-color-adjust: exact !important;
                display: block !important;
                visibility: visible !important;
              }
            }
          </style>
        </head>
        <body>
          ${printContent.outerHTML}
        </body>
      </html>
    `);
    iframeDoc.close();

    // Fix image src in the iframe's document to use absolute URLs
    const allImages = iframeDoc.querySelectorAll("img");
    allImages.forEach((img) => {
      const src = img.getAttribute("src") || "";
      if (src && !/^https?:\/\//i.test(src) && !/^data:/i.test(src)) {
        img.setAttribute(
          "src",
          `${window.location.origin}${src.startsWith("/") ? src : `/${src}`}`
        );
      }
    });

    const triggerPrint = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
        resolve(true);
      } catch (e) {
        console.error("Printing failed:", e);
        resolve(false);
      }
    };

    // Wait for images to load
    const images = iframeDoc.images;
    if (images.length > 0) {
      let loadedCount = 0;
      const onImageReady = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          setTimeout(triggerPrint, 300);
        }
      };
      for (const img of Array.from(images)) {
        if (img.complete) {
          onImageReady();
        } else {
          img.onload = onImageReady;
          img.onerror = onImageReady;
        }
      }
    } else {
      setTimeout(triggerPrint, 300);
    }
  });
}

export default function utility() {}
